import {createSlice} from "@reduxjs/toolkit";
import {config} from "../utils/Constants";

const initialState = {
    formValues: {}
};

const bankAccountDetails = createSlice({
    name: "bankAccountDetails",
    initialState,
    reducers: {
        setFormValue: (state, action) => {
            const { fieldID, value } = action.payload;
            state.formValues[fieldID] = value;
        },
        resetFormValues: (state) => {
            state.formValues = initialState.formValues;
        }
    }
});

export const { setFormValue, resetFormValues } = bankAccountDetails.actions;
export default bankAccountDetails.reducer;